import React, { useState } from 'react';
import './appraisal.css'
import { appraisalTableData } from '../../utils'
import { Link } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Loader from '../../components/loader/Loader'
import { submitAppraisal } from '../../api/appraisalApi'
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

// Create a SweetAlert2 instance with React integration
const MySwal = withReactContent(Swal);


const Appraisal = () => {
    const {user} = useSelector((state)=>state.user)
    const [isLoading, setIsLoading] = useState(false)
    const [innovation, setInnovation] = useState('')
    const [achievement, setAcchievement] = useState('')
    const [scores, setScores] = useState([]);

    // Function to handle input change
    const handleInputChange = (rowIndex, colIndex, value) => {
        const updatedScores = [...scores];
        while (updatedScores.length <= rowIndex) {
            updatedScores.push([]);
        }
        updatedScores[rowIndex][colIndex] = value;
        setScores(updatedScores);
    };

    const handleAppraisal = async () => {
        setIsLoading(true)
        try {
            const flatScores = scores.flat();
            const data = {
                appraisal: appraisalTableData.map(data => ({
                    kra: data.keyResultArea,
                    kpi: data.keyPerformanceIndicators.map((item, index) => ({
                        name: item,
                        score: { user: flatScores[index], hr: '', admin: '' }
                    }))
                })),
                achievement: achievement,
                innovation: innovation
            }

            const res = await submitAppraisal(user?.token, data)
            if(res?.success){
                setScores([])
                setInnovation('')
                setAcchievement('')
                MySwal.fire({
                    icon: 'success',
                    title: res?.message,
                    showConfirmButton: false,
                    timer: 2000
                });
            }else{
                MySwal.fire({
                    icon: 'error',
                    title: res?.message,
                    showConfirmButton: false,
                    timer: 2000
                });
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            console.log(error)
            MySwal.fire({
                icon: 'error',
                title: "There's an error processing your request, Try again",
                showConfirmButton: false,
                timer: 2000
            });
        }
    }


    return (
        <section className='appraisal'>

            {/* HEADING */}
            <div className="heading">
                <div className="heading__box">
                    <div className="heading-item">
                        <h3 className="heading-title">Appraisal | </h3>
                        <i class='bx bx-home heading__title-icon'></i>
                        <Link to="/" className="heading-text">
                            Home <i class='bx bx-chevron-right heading-icon'></i>
                        </Link>
                        <span className="heading-text">
                            Appraisal <i class='bx bx-chevron-right heading-icon'></i>
                        </span>
                    </div>
                    <p className="heading-text">
                        Submit Appraisal
                    </p>
                </div>
            </div>

            {/* APPRAISAL CONTAINER */}
            <div className="appraisal__form">

                <div className="appraisal__user-info">
                    <h4 className="appraisal__user-info__title">User Information</h4>
                    <div className="appraisal__user-item">
                        <div className="appraisal__user-field">
                            <label htmlFor="name" className="appraisal__user-label">
                                Name
                            </label>
                            <input type="text" className="appraisal__user-input" 
                            id="name" name="name" value={user?.firstName + ' ' + user?.lastName} 
                            readonly/>
                        </div>
                        <div className="appraisal__user-field">
                            <label htmlFor="staffId" className="appraisal__user-label">
                                Staff ID
                            </label>
                            <input type="text" className="appraisal__user-input" 
                            id="name" name="staffId"value={user?.staffId} readOnly/>
                        </div>
                    </div>
                </div>

                <div className="appraisal__content">
                    <h4 className="appraisal__content-title">
                        Performance Rating/Scoring Criteria
                    </h4>

                    <div className="appraisal__content-note">
                        <h4 className="appraisal__content-note_title">
                            Key Factors
                        </h4>
                        <span className="appraisal__content-note_span">
                            <span>5 = </span> Exceptional {'(Constantly exceeds position requirements – i.e. more than 90%)'}
                        </span>
                        <span className="appraisal__content-note_span">
                            <span>4 =</span> Exceeded Expectations {'(Constantly meets and occasionally exceeds position requirements – i.e. 81 – 90%)'}
                        </span>
                        <span className="appraisal__content-note_span">
                            <span>3 =</span> Satisfactory {'(Mostly meets the position requirements – i.e. 70 − 80% achievement)'}
                        </span>
                        <span className="appraisal__content-note_span">
                            <span>2 =</span> Requires Improvement {'(Occasionally doesn’t meet minimum requirement – i.e. 50−69%)'}
                        </span>
                        <span className="appraisal__content-note_span">
                            <span>1 =</span> Unsatisfactory {'(Does not meet minimum position requirement – i.e. <50% achievement)'}
                        </span>
                    </div>
                </div>

                <div className="appraisal__form-table">
                    <h4 className="appraisal__content-title">
                        Appraisal Table
                    </h4>

                    <div className='appraisal__table-container'>
                        <table className="appraisal__table">
                            <thead className='table__head'>
                                <tr>
                                    <th>#</th>
                                    <th>Key Result Area</th>
                                    <th>Key Performance Indicator</th>
                                    <th>Value</th>
                                </tr>
                            </thead>
                            <tbody className='table__body'>
                                
                                {
                                    appraisalTableData.map((data, rowIndex)=>(
                                        <tr className='table-parent_tr' key={data.id}>
                                            <td className='flex-1'>{data.id}</td>
                                            <td className='flex-2'>{data.keyResultArea}</td>
                                            <td className='flex-3'>
                                                <tr className='table-child_tr'>
                                                    {
                                                        data.keyPerformanceIndicators.map((item, i)=>(
                                                            <td key={i}>{item}</td>
                                                        ))
                                                    }
                                                </tr>
                                            </td>
                                            <td className='flex-4'>
                                                <tr className='table-child_tr'>
                                                    {
                                                        data.keyPerformanceIndicators.map((item, colIndex)=>(
                                                            <td key={colIndex}>
                                                                <input type="number"
                                                                    className="appraisal__table-input"
                                                                    id={`staffScore_${rowIndex}_${colIndex}`}
                                                                    value={scores[rowIndex]?.[colIndex] || ''}
                                                                    onChange={(e) => handleInputChange(rowIndex, colIndex, e.target.value)}
                                                                    min="1"
                                                                    max="5"
                                                                    required
                                                                />
                                                            </td>
                                                        ))
                                                    }
                                                </tr>
                                            </td>
                                        </tr>
                                    ))
                                }

                            </tbody>
                        </table>
                    </div>

                    <div className="appraisal__form-item">
                        <label htmlFor="achievemnt" className="appraisal__form-label">
                            List Job Achieved
                        </label>
                            <ReactQuill
                            name="issue"
                            theme="snow"
                            value={achievement}
                            onChange={(content) => setAcchievement(content)}
                            style={{minWidth: '100%'}}
                            />
                    </div>

                    <div className="appraisal__form-item">
                        <label htmlFor="innovations" className="appraisal__form-label">
                            New Innovations
                        </label>
                        <ReactQuill
                        name="issue"
                        theme="snow"
                        value={innovation}
                        onChange={(content) => setInnovation(content)}
                        style={{minWidth: '100%'}}
                        />
                    </div>

                    <div className="appraisal__form-item">
                        {isLoading ? <Loader/> : <button onClick={()=>handleAppraisal()}
                        type="submit" 
                        className="appraisal__form-btn button">
                            Submit Appraisal
                        </button>}
                    </div>

                </div>

            </div>
        </section>
    )
}

export default Appraisal